import React from "react";

// Literal, safelist-free Tailwind classes per variant - the previous version
// built classes dynamically (`bg-${bgColor}-500`), which Tailwind's JIT
// scanner can never discover (it only matches literal class-shaped tokens in
// source), so every button in the app was actually rendering with no
// background/hover color at all. These are real, static class strings.
const VARIANT_CLASSES = {
    primary   : 'bg-pink-600 text-white shadow-sm hover:bg-pink-700 focus-visible:ring-pink-500',
    secondary : 'bg-white text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:ring-pink-500',
    danger    : 'bg-red-600 text-white shadow-sm hover:bg-red-700 focus-visible:ring-red-500',
};

// Older call sites pass bgColor/color (e.g. bgColor="white" color="black" for
// a secondary button) instead of a variant - this keeps those working
// unchanged by mapping the handful of values actually used in the app onto
// the new variants.
const resolveVariant = (props) => {
    if (props.variant) {
        return props.variant;
    }

    switch (props.bgColor) {
        case 'white':
        case 'gray':
            return 'secondary';
        case 'red':
            return 'danger';
        default:
            return 'primary';
    }
};

const Button = (props) => {
    const variantClasses = VARIANT_CLASSES[resolveVariant(props)] || VARIANT_CLASSES.primary;

    return (
        <button
            type={props.isSubmit ? 'submit' : 'button'}
            onClick={props.isSubmit ? null : props.handleClick}
            disabled={props.disabled}
            className={`inline-flex items-center justify-center rounded-lg mx-1 px-4 py-2 text-sm font-semibold transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${variantClasses}`}
        >
            {props.title}
        </button>
    );
}

export default Button;
